import { FormInstance } from 'antd';
import React, { FC, useCallback } from 'react';
import { Button, ButtonSize } from 'shared/ui/Button';

interface ContinueButtonProps {
  formInstance: FormInstance;
  isDisabled: boolean;
  setProceedToPaymentMode: () => void;
  label: string;
  size?: ButtonSize;
}

export const ContinueButton: FC<ContinueButtonProps> = (props) => {
  const { isDisabled, setProceedToPaymentMode, formInstance, label, size = 'medium' } = props;

  const handleSubmit = useCallback(() => {
    setProceedToPaymentMode();
    formInstance.submit();
  }, [formInstance, setProceedToPaymentMode]);

  return (
    <>
      <Button containerClassName="w-full" size={size} isDisabled={isDisabled} onClick={handleSubmit}>
        {label}
      </Button>
    </>
  );
};
